import type { InvoiceAverageComparison } from "../types/payment";

const AVERAGE_MATCH_TOLERANCE_PERCENT = 2;

const compareInvoiceAmountToAverage = (amount: number | null, average: number | null): InvoiceAverageComparison | null => {
  if (!amount || !average) return null;
  const ratio = (amount / average) * 100;
  if (Math.abs(ratio - 100) < AVERAGE_MATCH_TOLERANCE_PERCENT) return "matches";
  return ratio > 100 ? "above" : "below";
};

const formatAddressProviderLabel = (addressName: string, providerName: string): string => `${addressName} · ${providerName}`;

export { compareInvoiceAmountToAverage, formatAddressProviderLabel };
